import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from '../api/API';
import { Context_UI } from "./Context_UI";

const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [Token, Token_Set] = useState(localStorage.getItem('Token'));
    const [Account, Account_Set] = useState(null);
    const [Loading, Loading_Set] = useState(true);
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();

    useEffect(() => {
        if (!Token) {
            Account_Set(null);
            Loading_Set(false);
            return;
        }

        Loading_Set(true);

        API
            .get("Accounts/Profile", {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            })
            .then(res => {
                Account_Set(setData(res.data));
            })
            .catch((err) => {
                console.log("Token had been removed: ", err);
                localStorage.removeItem("Token");
                Token_Set(null);
                Account_Set(null);
            })
            .finally(() => {
                Loading_Set(false);
                
            });
    }, [Token]);

    const Login = (Token_New) => {
        localStorage.setItem("Token", Token_New);
        UI.LoadingScreen_Show("Screen_Loading");
        Token_Set(Token_New);
        setTimeout(function () {
            Navigate("/home");
            window.App_Reset();
        }, 500);
    }

    const Logout = () => {
        localStorage.removeItem("Token");
        UI.Page_ChangePage("/", "Loading");
        window.App_Reset();
        Token_Set(null);
    }

    const setData = (Data) => {
        return setPayload(Data);
    }

    const setPayload = (Data) => {
        const Payload = {
            _id: Data._id,
            Name: {
                First: Data.Name.First,
                MI: Data.Name.MI,
                Last: Data.Name.Last
            },
            Name_Compounded: `${Data.Name.First} ${Data.Name.MI ? Data.Name.MI + "." : ""} ${Data.Name.Last}`,
            Email: Data.Email,
            Access: Data.Access,
            Approval: Data.Approval,
            isSystemAdmin: Data.isSystemAdmin
        }
        return Payload;
    }


    return (
        <AuthContext.Provider value={{ Account, Loading, Login, Logout }}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    return useContext(AuthContext);
}